var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        " fixed z-a1 bg-black-80 inset-0 overflow-auto scrolling-touch",
      attrs: { id: "focus-trap" }
    },
    [
      _c(
        "div",
        {
          staticClass: "global-container-xl global-padding py-20 min-h-screenh"
        },
        [
          _c(
            "div",
            {
              staticClass: "p-6 md:p-8 card max-w-6xl w-full m-auto relative",
              attrs: { id: "card-container" }
            },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute bg-white-80 inset-0 z-1 text-black flex items-center justify-center p-8"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("svg-icon", {
                            staticClass: "text-black",
                            attrs: { icon: "tail-spin", size: "8" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "uppercase font-bold text-12 tracking-serif"
                            },
                            [_vm._v("Loading")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "portal-target",
                { staticClass: "mb-4 md:mb-12", attrs: { name: "navbar" } },
                [
                  _c(
                    "div",
                    { staticClass: "h-4 mb-4" },
                    [
                      _vm.nextUrl
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "inline-block antialiased text-16 text-lightgrey-d font-bold",
                              attrs: { to: _vm.nextUrl }
                            },
                            [_vm._v("Skip")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-14 font-light opacity-85 text-theme-fg"
                    },
                    [
                      _vm._v(
                        "Question " +
                          _vm._s(_vm.$route.params.step) +
                          " / " +
                          _vm._s(_vm.questions.length)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex rounded-lg overflow-hidden pt-1 pb-2"
                    },
                    _vm._l(_vm.questions, function(question) {
                      return _c(
                        "router-link",
                        {
                          key: "question-" + question.i,
                          staticClass:
                            "inline-block relative flex-grow flex-shrink px-2 leading-none leading-medium py-1 text-12 rounded-lg mx-px text-white block m-0 hover:opacity-100 tab-link",
                          class: {
                            " bg-blue bg-theme-highlight opacity-70":
                              _vm.$route.params.step > question.i,
                            " bg-blue bg-theme-highlight":
                              _vm.$route.params.step === question.i,
                            "bg-black-20 hover:bg-black-60":
                              _vm.$route.params.step < question.i
                          },
                          attrs: {
                            "aria-label": "Go to " + question.i,
                            to: "/" + _vm.slug + "/" + question.i + "/"
                          }
                        },
                        [_c("div", { staticClass: "inset-0 absolute -my-2" })]
                      )
                    }),
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "relative z-0",
                  class: {
                    //  'opacity-0 pointer-events-none': loading
                  }
                },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "z-5 absolute right-0 top-0 text-black m-4",
                  attrs: { to: "/", "aria-label": "Close" }
                },
                [_c("svg-icon", { attrs: { icon: "close", size: "4" } })],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("store-error")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }